'use strict'
/**
 * Created by hanyongshan on 2021/6/3.
 */
import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export function list() {
  return Axios({
    url: requestPrefix.projectUrl + '/sysIcon/list',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/logomanage/index.js